export default function ChamadaFinal() {
  const scrollToInvestimento = () => {
    const element = document.getElementById('investimento');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      {/* Dramatic Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900 via-dark-800 to-dark-900"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] md:w-[1400px] h-[500px] md:h-[800px] bg-gradient-radial from-neon-blue/30 via-neon-purple/20 to-transparent blur-[80px] md:blur-[120px] animate-pulse-slow"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Main Card */}
          <div className="relative bg-dark-800/60 backdrop-blur-2xl border-2 border-neon-blue/40 rounded-3xl md:rounded-[4rem] p-8 md:p-16 lg:p-24 shadow-[0_0_80px_rgba(0,212,255,0.5)] md:shadow-[0_0_120px_rgba(0,212,255,0.5)] text-center">
            {/* Animated Icon */}
            <div className="mb-8 md:mb-12 flex justify-center">
              <div className="relative">
                <div className="w-20 h-20 md:w-32 md:h-32 bg-gradient-to-br from-neon-blue to-neon-purple rounded-2xl md:rounded-3xl flex items-center justify-center shadow-[0_0_40px_rgba(0,212,255,0.6)] md:shadow-[0_0_60px_rgba(0,212,255,0.6)] animate-float">
                  <i className="ri-rocket-2-fill text-4xl md:text-6xl text-white"></i>
                </div>
                <div className="absolute -top-2 md:-top-4 -right-2 md:-right-4 w-8 h-8 md:w-12 md:h-12 bg-neon-pink rounded-full flex items-center justify-center animate-pulse">
                  <i className="ri-sparkling-fill text-base md:text-2xl text-white"></i>
                </div>
              </div>
            </div>

            {/* Main Message */}
            <div className="space-y-6 md:space-y-8 mb-10 md:mb-16">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black text-white leading-tight px-2">
                Seu Filho Não Pode Esperar o Futuro Chegar.
              </h2>
              <p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink bg-clip-text text-transparent leading-tight px-2">
                Ele Deve Criá-lo Agora!
              </p>
            </div>

            {/* Supporting Text */}
            <div className="space-y-4 md:space-y-6 mb-8 md:mb-12 max-w-4xl mx-auto">
              <p className="text-lg md:text-2xl text-gray-300 leading-relaxed px-2">
                Cada dia que passa é uma oportunidade perdida. Enquanto outras crianças continuam no sistema tradicional, <strong className="text-white">seu filho pode estar 10 anos à frente</strong>.
              </p>
              <p className="text-base md:text-xl text-gray-400 leading-relaxed px-2">
                A decisão que você toma hoje vai definir o amanhã dele.
              </p>
            </div>

            {/* Urgency Box */}
            <div className="bg-gradient-to-r from-red-500/10 to-orange-500/10 border-2 border-red-500/30 rounded-2xl md:rounded-3xl p-6 md:p-8 mb-8 md:mb-12 max-w-3xl mx-auto">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-3 md:mb-4">
                <i className="ri-alarm-warning-fill text-3xl md:text-4xl text-red-400 animate-pulse"></i>
                <p className="text-xl md:text-2xl font-bold text-white text-center sm:text-left">Atenção: Vagas Limitadas</p>
              </div>
              <p className="text-sm md:text-lg text-gray-300 px-2">
                Para garantir qualidade máxima, aceitamos apenas <strong className="text-white">20 alunos por turma</strong>.
              </p>
            </div>

            {/* Final CTA */}
            <div className="space-y-4 md:space-y-6">
              <button 
                onClick={scrollToInvestimento}
                className="w-full sm:w-auto group relative px-6 md:px-12 py-5 md:py-7 bg-gradient-to-r from-neon-blue to-neon-purple rounded-xl md:rounded-2xl font-black text-xl md:text-3xl text-white overflow-hidden transition-all duration-300 hover:scale-110 hover:shadow-[0_0_80px_rgba(0,212,255,1)] whitespace-nowrap cursor-pointer"
              >
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-4">
                  <i className="ri-rocket-2-fill text-2xl md:text-4xl"></i>
                  <span className="hidden sm:inline">Quero Garantir a Vaga Agora</span>
                  <span className="sm:hidden">Garantir Vaga</span>
                  <i className="ri-arrow-right-line text-2xl md:text-4xl group-hover:translate-x-2 transition-transform duration-300"></i>
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-neon-purple to-neon-pink opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>

              <p className="text-gray-400 text-xs md:text-sm">
                <i className="ri-lock-fill text-neon-blue mr-2"></i>
                Pagamento 100% seguro
              </p>
            </div>

            {/* Social Proof */}
            <div className="mt-10 md:mt-16 pt-8 md:pt-12 border-t border-neon-blue/20">
              <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
                <div className="text-center">
                  <p className="text-3xl md:text-4xl font-black text-neon-blue mb-1 md:mb-2">+500</p>
                  <p className="text-gray-400 text-xs md:text-base">Alunos Transformados</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl md:text-4xl font-black text-neon-purple mb-1 md:mb-2">4.9★</p>
                  <p className="text-gray-400 text-xs md:text-base">Avaliação Média</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl md:text-4xl font-black text-neon-pink mb-1 md:mb-2">98%</p>
                  <p className="text-gray-400 text-xs md:text-base">Pais Satisfeitos</p>
                </div>
              </div>
            </div>

            {/* Glow Effects */}
            <div className="absolute inset-0 bg-gradient-to-br from-neon-blue/5 via-neon-purple/5 to-neon-pink/5 rounded-3xl md:rounded-[4rem] pointer-events-none"></div>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 md:w-64 h-40 md:h-64 bg-neon-blue/30 rounded-full blur-[60px] md:blur-[100px]"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
